import { isUndefined, omitBy } from "lodash";
import useQueryParams from "./useQueryParams";

const useQueryConfig = () => {
  const queryParams = useQueryParams();

  const queryConfig = omitBy(
    {
      page: queryParams.page || "1",
      limit: queryParams.limit || "10",
      // limit: "10",
      // thay đổi limit ở đây cũng phải thay đổi lại limit trên server
      iconType: queryParams.iconType || "device",
      categoryId: queryParams.categoryId || "",
      iotPartnerId: queryParams.iotPartnerId || "",
      search: queryParams.search || "",
    },
    isUndefined
  );
  return queryConfig;
};

export default useQueryConfig;
